import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import CareFacilityUsersListings from "../components/Admin/ClientUser/CareFacilityUsersListings";

function CareFacilityUserListingsPage()  {
    return(
        <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={false} />
                </div>
              <div className="content-class">
                <CareFacilityUsersListings />
              </div>
              <div className="footer-class">
                  <Footer />
              </div>
            </div>
        </div>
        </>
    );
}

export default CareFacilityUserListingsPage;